
import Handsontable from "handsontable";
import { RateItem } from "../../models";

/*
Custom renderer for dropdown cells that have validation errors in rate item processing.

 * @param hot The Handsontable instance.
 * @param td The table cell.
 * @param row The row index.
 * @param column The column index.
 * @param prop The property.
 * @param value The value.
 * @param cellProperties The cell properties.
 */
export function isgRendererDropDownNoValidation(
  this: any
  , hot: Handsontable
  , td: any
  , row: number
  , column: number
  , prop: any
  , value: any
  , cellProperties: any) {

  const args: [Handsontable, any, number, number, string | number, any, Handsontable.CellProperties] =
    [hot, td, row, column, prop, value, cellProperties];

  Handsontable.renderers.DropdownRenderer.apply(this, args);
}
